import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ForgotPasswordModel } from 'common/models/page-models/Login/forgot-password/forgot-password-data-model';

import { FormResolverService } from 'common/resolvers/core-resolvers/form-resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { ForgotPasswordFormWidgetService } from 'common/widget/login/forgotPassword-form-widget';


@Injectable({
    providedIn: 'root'
})
export class ForgotPasswordFormResolver extends FormResolverService<ForgotPasswordModel> {
    constructor(
        protected fs: ForgotPasswordFormWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);

    }

    // override modifyResponseData(dataModel, meta, widget) {
    //     dataModel['email'] = widget.transferData.email;
    //     return dataModel;
    // }
}

